import { ContentStateInterface, Salutation } from '../../../../../../@types/types'
import { RealEstateContact } from '../../../../../../@types/real-estate-api-types'
import {
  removeExtraWhitespaces,
  removeExtraWhitespacesWithoutUndefined,
} from '../../../../../../services/conversion/conversionServices'

export const contactToApi = (insertionData: ContentStateInterface): RealEstateContact => ({
  contactId: insertionData.contactId,
  externalId: insertionData.externalContactId,
  salutationType: insertionData.salutation ?? Salutation.NO_SALUTATION,
  firstName: insertionData.firstName ? removeExtraWhitespaces(insertionData.firstName) : undefined,
  lastName: insertionData.lastName ? removeExtraWhitespacesWithoutUndefined(insertionData.lastName) : '',
  phoneNumber: removeExtraWhitespaces(insertionData.phoneNumber),
  email: insertionData.email ? removeExtraWhitespacesWithoutUndefined(insertionData.email) : undefined,
})
